var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-row', {
    staticClass: "row--small",
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', [_c('v-text-field', _vm._b({
    model: {
      value: _vm.phone1,
      callback: function ($$v) {
        _vm.phone1 = $$v;
      },
      expression: "phone1"
    }
  }, 'v-text-field', Object.assign({}, _vm.$attrs, {
    label: _vm.label,
    readonly: _vm.readonly
  }), false))], 1), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_vm._v("-")]), _c('v-col', [_c('v-text-field', _vm._b({
    model: {
      value: _vm.phone2,
      callback: function ($$v) {
        _vm.phone2 = $$v;
      },
      expression: "phone2"
    }
  }, 'v-text-field', Object.assign({}, _vm.$attrs, {
    readonly: _vm.readonly
  }), false))], 1), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_vm._v("-")]), _c('v-col', [_c('v-text-field', _vm._b({
    model: {
      value: _vm.phone3,
      callback: function ($$v) {
        _vm.phone3 = $$v;
      },
      expression: "phone3"
    }
  }, 'v-text-field', Object.assign({}, _vm.$attrs, {
    readonly: _vm.readonly
  }), false))], 1), _vm.hasCertification ? [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "auto"
    }
  }, [_c('v-btn', {
    staticClass: "w-100 w-sm-120px v-btn--input",
    attrs: {
      "tile": "",
      "color": "primary"
    },
    on: {
      "click": _vm.certify
    }
  }, [_vm._v("본인인증")])], 1), _c('kcp-cert', {
    ref: "kcp-cert",
    on: {
      "input": _vm.processCertifiedData
    }
  })] : _vm._e()], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }